import { useState, useEffect } from "react";
import SidebarContent from "./SidebarContent";

export default function Sidebar() {
  const [isCollapsed, setIsCollapsed] = useState(false);

  // Auto collapse on small viewports
  useEffect(() => {
    const handleResize = () => {
      setIsCollapsed(window.innerWidth < 768); // md breakpoint
    };

    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      className={`h-screen sticky top-0 transition-all duration-300 bg-white dark:bg-gray-950 ${
        isCollapsed ? "w-16" : "w-64"
      }`}
    >
      <SidebarContent
        isCollapsed={isCollapsed}
        onToggleCollapse={() => setIsCollapsed(!isCollapsed)}
      />
    </div>
  );
}
